import React from 'react'
import { Route as ReactDOMRoute, Redirect } from 'react-router-dom'
import { useTokenApi } from '../hooks/useTokenApi'

function Route({ isPrivate = true, component: Component, ...rest }: any) {
  const { tokenApi } = useTokenApi()

  // Bootstrap de sessão em andamento: não decide rota ainda.
  if (tokenApi === undefined) return null

  return (
    <ReactDOMRoute
      {...rest}
      render={({ location }) => {
        return isPrivate ? (
          <Component />
        ) : (
          <Redirect
            to={{
              pathname: isPrivate ? '/' : '/login',
              state: { from: location }
            }}
          />
        )
      }}
    />
  )
}

export default Route
